import React, { Component } from 'react'
import { Route, Switch } from 'react-router-dom'
import Home from '../home'
import About from '../about'
import PrivacyPolicy from '../static/privacy'
import ConfirmEmail from '../confirmemail'
import LoginEmail from '../loginemail'
import Appeal from '../appeal'
import NoMatch from '../nomatch'
import AdminLayout from '../admin/AdminLayout/AdminLayout'
import Layout from '../Layout/Layout'
import AdminDashBoard from '../admin/AdminDashBoard/AdminDashBoard'
import AdminLogin from '../admin/AdminLogin/AdminLogin'
import AdminPin from '../admin/AdminLogin/AdminPin'
import AdminUsers from '../admin/AdminUsers/AdminUsers'
import AdminUserEdit from '../admin/AdminUsers/AdminUserEdit'
import AdminUserCreate from '../admin/AdminUsers/AdminUserCreate'
import AdminAppeal from '../admin/AdminAppeal/AdminAppeal'
import AdminAppealResponses from '../admin/AdminAppeal/AdminAppealResponses'
import AdminResponseCreate from '../admin/AdminResponses/AdminResponseCreate'
import AdminResponseEdit from '../admin/AdminResponses/AdminResponseEdit'
import AdminResponses from '../admin/AdminResponses/AdminResponses'
import CreateAppeal from '../admin/AdminDashBoard/CreateAppeal'
import { ToastContainer } from 'react-toastify'
import { connect } from 'react-redux'
import { withRouter } from 'react-router'
import PropTypes from 'prop-types'
import AppealMessages from '../appeal/AppealMessages'
import AdminReasons from '../admin/AdminReasons/AdminReasons'
import AdminReasonEdit from '../admin/AdminReasons/AdminReasonEdit'
import AdminReasonCreate from '../admin/AdminReasons/AdminReasonCreate'
import AdminAppealPDF from '../admin/AdminAppeal/AdminAppealPDF'

class App extends Component {
  render () {
    return (
      <div>
        <main>
          <ToastContainer />
          <div>
            <Switch location={this.props.location}>
              <Route exact path='/' render={() => <Layout><Home /></Layout>} />
              <Route exact path='/about-us' render={() => <Layout><About /></Layout>} />
              <Route exact path='/confirm-email' render={() => <Layout><ConfirmEmail /></Layout>} />
              <Route exact path='/login-email' render={() => <Layout><LoginEmail /></Layout>} />
              <Route exact path='/appeal/:appealID([0-9a-fA-f-]{36})' render={() => <Layout><Appeal /></Layout>} />
              <Route exact path='/appeal/:appealID([0-9a-fA-f-]{36})/messages' render={() => <Layout><AppealMessages /></Layout>} />
              <Route exact path='/privacy-statement' render={() => <Layout><PrivacyPolicy /></Layout>} />
              <Route exact path='/admin' render={() => <AdminLayout><AdminDashBoard /></AdminLayout>} />
              <Route exact path='/admin/login' render={() => <Layout><AdminLogin /></Layout>} />
              <Route exact path='/admin/pin' render={() => <Layout><AdminPin /></Layout>} />
              <Route exact path='/admin/:accessToken([0-9a-fA-f-]{36})' render={() => <AdminLayout><AdminDashBoard /></AdminLayout>} />
              <Route exact path='/admin/users' render={() => <AdminLayout><AdminUsers /></AdminLayout>} />
              <Route exact path='/admin/user/create' render={() => <AdminLayout><AdminUserCreate /></AdminLayout>} />
              <Route exact path='/admin/user/:email' render={() => <AdminLayout><AdminUserEdit /></AdminLayout>} />
              <Route exact path='/admin/reasons' render={() => <AdminLayout><AdminReasons /></AdminLayout>} />
              <Route exact path='/admin/reason/create' render={() => <AdminLayout><AdminReasonCreate /></AdminLayout>} />
              <Route exact path='/admin/reason/:id' render={() => <AdminLayout><AdminReasonEdit /></AdminLayout>} />
              <Route exact path='/admin/appeal/:appealID([0-9a-fA-f-]{36})' render={() => <AdminLayout><AdminAppeal /></AdminLayout>} />
              <Route exact path='/admin/appeal/:appealID([0-9a-fA-f-]{36})/messaging' render={() => <AdminLayout><AdminAppealResponses /></AdminLayout>} />
              <Route exact path='/admin/appeal/:appealID([0-9a-fA-f-]{36})/pdf' render={() => <AdminLayout><AdminAppealPDF /></AdminLayout>} />
              <Route exact path='/admin/responses' render={() => <AdminLayout><AdminResponses /></AdminLayout>} />
              <Route exact path='/admin/response/create' render={() => <AdminLayout><AdminResponseCreate /></AdminLayout>} />
              <Route exact path='/admin/responses/:id([0-9]*)' render={() => <AdminLayout><AdminResponseEdit /></AdminLayout>} />
              <Route exact path='/admin/create' render={() => <AdminLayout><CreateAppeal /></AdminLayout>} />

              <Route component={NoMatch} />
            </Switch>
          </div>

        </main>
      </div>
    )
  }
}

App.propTypes = {
  location: PropTypes.object
}

const mapStateToProps = (state) => ({

})

export default withRouter(connect(mapStateToProps)(App))



// WEBPACK FOOTER //
// ./src/containers/app/index.jsx